var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 18.9014C4 17.8405 4.42143 16.8231 5.17157 16.0729C5.92172 15.3228 6.93913 14.9014 8 14.9014H16C17.0609 14.9014 18.0783 15.3228 18.8284 16.0729C19.5786 16.8231 20 17.8405 20 18.9014C20 19.4318 19.7893 19.9405 19.4142 20.3156C19.0391 20.6907 18.5304 20.9014 18 20.9014H6C5.46957 20.9014 4.96086 20.6907 4.58579 20.3156C4.21071 19.9405 4 19.4318 4 18.9014Z",
    stroke: "#71839B",
    strokeWidth: 0.875,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.9014C13.6569 10.9014 15 9.55822 15 7.90137C15 6.24451 13.6569 4.90137 12 4.90137C10.3431 4.90137 9 6.24451 9 7.90137C9 9.55822 10.3431 10.9014 12 10.9014Z",
    stroke: "#71839B",
    strokeWidth: 0.875
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.c7dac32dfdceb81088641a580a1b11a1.svg";
export { ForwardRef as ReactComponent };